import { useMemo } from "react";

import {
  NestedKey,
  NestedValue,
  ProgressBarTierVariables,
} from "@intelligems/ig-types";
import { useDispatch, useSelector } from "@src/store";
import { setUserInterfaceVariable } from "@src/store/slices/userInterfaces";
import { getUserInterfaceVariable } from "@src/store/slices/userInterfaces/selectors";
import { UserInterfaceField } from "@src/store/slices/userInterfaces/types";

export function useProgressBarTierVariable<
  T extends NestedKey<ProgressBarTierVariables>,
>(interfaceId: string, tierId: string, key: T) {
  const dispatch = useDispatch();

  const path = `textReplacements.tierVariables[${tierId}].${key}`;
  const value = useSelector(
    getUserInterfaceVariable(interfaceId, path)
  ) as NestedValue<ProgressBarTierVariables, T>;

  return useMemo(() => {
    const setValue = (value: NestedValue<ProgressBarTierVariables, T>) => {
      dispatch(
        setUserInterfaceVariable({
          interfaceId,
          path,
          value,
        })
      );
    };
    return [value, setValue] as UserInterfaceField<
      NestedValue<ProgressBarTierVariables, T>
    >;
  }, [value, interfaceId, path]);
}
